import script from "./Signsure.vue?vue&type=script&lang=ts&setup=true"
export * from "./Signsure.vue?vue&type=script&lang=ts&setup=true"

import "./Signsure.vue?vue&type=style&index=0&id=a434c866&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a434c866"]])

export default __exports__